import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import UITourFinishButton from 'ui-shepherd-react/button/UITourFinishButton';
import { openTaskCompletionModal } from '../util/banner';

const OnboardingTourFinishButton = props => {
  const {
    beforeFinish,
    taskKey
  } = props,
        buttonProps = _objectWithoutPropertiesLoose(props, ["beforeFinish", "taskKey"]);

  return /*#__PURE__*/_jsx(UITourFinishButton, Object.assign({
    beforeFinish: ({
      tourKey,
      stepKey
    }) => {
      if (taskKey) {
        openTaskCompletionModal(taskKey);
      }

      if (typeof beforeFinish === 'function') {
        return beforeFinish(tourKey, stepKey);
      }

      return undefined;
    }
  }, buttonProps));
};

export default OnboardingTourFinishButton;